// extracted by mini-css-extract-plugin
module.exports = {"complete":"complete-module--complete--x3tTs","text":"complete-module--text--2fZId","button":"complete-module--button--1h9iI"};